module.exports = __webpack_public_path__ + "static/media/testimonials3.36743ff1.jpg";